type ActivityTagType = 'progress' | 'completed' | 'info' | 'error';

const ACTION_LABELS: Record<string, string> = {
  USER_ADDED: 'New user added',
  INVITE_SENT: 'Welcome invite sent',
  INVITE_RESENT: 'Welcome invite resent',
  USER_UPDATED: 'User updated',
  PASSWORD_RESET: 'Password reset',
  MFA_RESET: 'MFA reset',
  USER_DELETED: 'User deleted',
};

const ACTION_TAG_TYPES: Record<string, ActivityTagType> = {
  USER_ADDED: 'completed',
  INVITE_SENT: 'info',
  INVITE_RESENT: 'info',
  USER_UPDATED: 'progress',
  PASSWORD_RESET: 'progress',
  MFA_RESET: 'progress',
  USER_DELETED: 'error',
};

const isDeactivation = (details: Record<string, unknown> | null): boolean => String(details?.to ?? '') === 'INACTIVE';

const getActionLabel = (action: string, details: Record<string, unknown> | null = null): string => {
  if (action === 'STATUS_CHANGED') {
    return isDeactivation(details) ? 'User deactivated' : 'User activated';
  }
  return ACTION_LABELS[action] ?? action;
};

const getActionTagType = (action: string, details: Record<string, unknown> | null = null): ActivityTagType => {
  if (action === 'STATUS_CHANGED') {
    return isDeactivation(details) ? 'error' : 'completed';
  }
  return ACTION_TAG_TYPES[action] ?? 'info';
};

const formatActivityDetails = (action: string, details: Record<string, unknown> | null): string[] => {
  if ((action === 'USER_UPDATED' || action === 'USER_ADDED') && details) {
    const lines: string[] = [];
    if (Array.isArray(details.roles) && details.roles.length > 0) {
      lines.push(`Roles: ${details.roles.join(', ')}`);
    }
    if (Array.isArray(details.cohorts) && details.cohorts.length > 0) {
      lines.push(`Cohorts: ${details.cohorts.join(', ')}`);
    }
    return lines.length > 0 ? lines : ['—'];
  }
  return ['—'];
};

export type { ActivityTagType };
export { getActionLabel, getActionTagType, formatActivityDetails };
